import { useTranslation } from '@/lib/i18n/i18n.client';

import { PostShareOption } from './types';

import facebookIcon from '~/icons/facebook.svg';
import linkedInIcon from '~/icons/iconLinkedInBlack.svg';
import whatsAppIcon from '~/icons/iconWhatsAppBlack.svg';
import telegramIcon from '~/icons/send-01.svg';
import twitterXIcon from '~/icons/twitter-x.svg';

export const buildSocialSharingOptions = (
  shareLinks: ReturnType<typeof buildShareLinks>,
  texts: ReturnType<typeof useTranslation>['texts']
): PostShareOption[] => [
  {
    id: 'whatsapp',
    icon: whatsAppIcon,
    label: texts.blog.whatsapp,
    url: shareLinks.whatsapp,
  },
  {
    id: 'telegram',
    icon: telegramIcon,
    label: texts.blog.telegram,
    url: shareLinks.telegram,
  },
  {
    id: 'linkedin',
    icon: linkedInIcon,
    label: texts.blog.linkedin,
    url: shareLinks.linkedin,
  },
  {
    id: 'twitter-x',
    icon: twitterXIcon,
    label: texts.blog.twitterX,
    url: shareLinks.twitterX,
  },
  {
    id: 'facebook',
    icon: facebookIcon,
    label: texts.blog.facebook,
    url: shareLinks.facebook,
  },
];

interface BuildSocialShareLinkParams {
  url: string;
  title: string;
}

export const buildShareLinks = ({ url, title }: BuildSocialShareLinkParams) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  return {
    linkedin: `https://www.linkedin.com/shareArticle?title=${encodedTitle}&url=${encodedUrl}`,
    telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`,
    twitterX: `https://x.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
  } as const;
};
